<script setup lang="ts">
definePageMeta({
  layout: 'public',
  title: 'layout.footer.imprint',
  isPublicPage: true,
})
</script>

<template>
  <LegalDocument type="data-security" />
</template>
